import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/about.jpg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "color-secondary bold" }, "About", -1)
const _hoisted_3 = { class: "heading bold mw-764 mt-16" }
const _hoisted_4 = {
  class: "button mt-32",
  href: "mailto:info@lennarthakker.com"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt-64 border-radius-6 ratio-16-9" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Lennart Hakker",
    src: _imports_0
  })
], -1)
const _hoisted_6 = { class: "mt-64 mb-64 grid grid--column-40-60 grid--grid-row-gap-64 grid--grid-row-gap-16-xs grid--column-full-xs" }
const _hoisted_7 = { class: "color-secondary bold text-align-right text-align-left-xs mr-100 mr-0-xs" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "color-secondary bold text-align-right text-align-left-xs mr-100 mr-0-xs" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"grid grid--column-1-1-1 grid--column-1-1-md\"><p>JavaScript</p><p>TypeScript</p><p>Vue</p><p>Vuex</p><p>Angular</p><p>NGRX</p><p>Svelte</p><p>RXJS</p><p>React</p><p>SCSS</p><p>BEM</p><p>Swift</p><p>UIKit</p><p>SwiftUI</p><p>ARKit</p><p>Firebase</p><p>Realm</p><p>Core data</p><p class=\"mb-16-xs\">Catalyst</p><p class=\"mb-16-xs\">WatchOS</p></div>", 1)
const _hoisted_11 = { class: "color-secondary bold text-align-right text-align-left-xs mr-100 mr-0-xs" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid--column-1-1-1 grid--column-1-1-md" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Adobe Illustrator"),
  /*#__PURE__*/_createElementVNode("p", null, "Adobe XD"),
  /*#__PURE__*/_createElementVNode("p", null, "Figma"),
  /*#__PURE__*/_createElementVNode("p", null, "Design systems"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-16-xs" }, "Atomic design patern"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-16-xs" }, "UX")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('about.title')), 1),
    _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$t('about.requestResume')), 1),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('about.experiences.title')), 1),
      _createElementVNode("p", {
        class: "mb-16-xs",
        innerHTML: _ctx.$t('about.experiences.text')
      }, null, 8, _hoisted_8),
      _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t('about.programmingSkills.title')), 1),
      _hoisted_10,
      _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('about.graphicDesign.title')), 1),
      _hoisted_12
    ])
  ]))
}